import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import closeIcon from "../../../../../../assets/icons/closeIcon.svg";
import { ProviderRequestsFilterOptionsProps } from "../search-and-filter-type";
import "./provider-requests-filter-options.scss";
import dayjs, { Dayjs } from "dayjs";
import ProviderRequestStatusFilter from "./status-filter";
import CreatedTimeFilter from "./created-timer-filter";

const ProviderRequestsFilterOptions: React.FC<
  ProviderRequestsFilterOptionsProps
> = (props: any) => {
  const {
    setIsOpenFilter,
    isOpenFilter,
    providerRequestsFilterOptions,
    setProviderRequestsFilterOptions,
    onApplyFilters,
    activeFilters,
  } = props;
  const [createdTime, setCreatedTime] = useState<string[]>([]);
  const [createdTimeError, setCreatedTimeError] = useState("");
  const [createdTimeStart, setCreatedTimeStart] = useState<Dayjs | null>(null);
  const [createdTimeEnd, setCreatedTimeEnd] = useState<Dayjs | null>(null);
  const [createdTimeStartError, setCreatedTimeStartError] = useState("");
  const [createdTimeEndError, setCreatedTimeEndError] = useState("");
  const [status, setStatus] = useState<string[]>([]);
  const [statusError, setStatusError] = useState("");
  const [businessType, setBusinessType] = useState<string[]>([]);
  const [businessTypeError, setBusinessTypeError] = useState("");

  const [
    draftProviderRequestsFilterOptions,
    setDraftProviderRequestsFilterOptions,
  ] = useState<any[]>([]);

  useEffect(() => {
    if (isOpenFilter) {
      // Step 1: Pre-check fields based on activeFilters
      const updatedDraft = providerRequestsFilterOptions?.map((option: any) => {
        switch (option.label) {
          case "Business Type":
            return {
              ...option,
              value: !!(
                activeFilters?.businessType &&
                activeFilters?.businessType.length
              ),
            };
          case "Status":
            return {
              ...option,
              value: !!activeFilters?.status?.length,
            };
          case "Requested Date Range":
            return {
              ...option,
              value: !!(
                activeFilters?.createdTimeStart && activeFilters?.createdTimeEnd
              ),
            };
          default:
            return option;
        }
      });

      setDraftProviderRequestsFilterOptions(updatedDraft);

      if (activeFilters?.createdTimeStart && activeFilters?.createdTimeEnd) {
        setCreatedTime(["Custom"]);
        setCreatedTimeStart(dayjs(activeFilters.createdTimeStart));
        setCreatedTimeEnd(dayjs(activeFilters.createdTimeEnd));
      }

      if (activeFilters?.status?.length) {
        setStatus(activeFilters.status);
      }
      if (activeFilters?.businessType?.length) {
        setBusinessType(activeFilters.businessType);
      }
    }
    if (!isOpenFilter) {
      setStatusError("");
      setCreatedTimeError("");
      setCreatedTimeStartError("");
      setCreatedTimeEndError("");
      setBusinessTypeError("");
    }
  }, [isOpenFilter]);

  const isAnyFilterSelected = draftProviderRequestsFilterOptions?.some(
    (option: any) => option.value
  );
  const handleChange = (e: any) => {
    const updatedDraft = draftProviderRequestsFilterOptions?.map((data: any) =>
      data?.label === e.target.id ? { ...data, value: !data?.value } : data
    );

    const isCreatedTimeChecked =
      e.target.id === "Requested Date Range" && e.target.checked;
    const isCreatedTimeUnchecked =
      e.target.id === "Requested Date Range" && !e.target.checked;
    if (isCreatedTimeChecked) {
      setCreatedTime(["Custom"]);
    }

    if (isCreatedTimeUnchecked) {
      setCreatedTime([]);
      setCreatedTimeStart(null);
      setCreatedTimeEnd(null);
      setCreatedTimeError("");
      setCreatedTimeStartError("");
      setCreatedTimeEndError("");
    }
    const isStatusChecked = e.target.id === "Status" && e.target.checked;
    const isStatusUnchecked = e.target.id === "Status" && !e.target.checked;
    const isBusinessTypeChecked = e.target.id === "Business Type" && e.target.checked;
    const isBusinessTypeUnchecked = e.target.id === "Business Type" && !e.target.checked;
    if (isStatusUnchecked) {
      setStatus([]);
      setStatusError("");
    }
    if (isBusinessTypeUnchecked) {
      setBusinessType([]);
      setBusinessTypeError("");
    }
     
    setDraftProviderRequestsFilterOptions(updatedDraft);
  };

  const handleReset = () => {
    const resetFilters = draftProviderRequestsFilterOptions?.map(
      (option: any) => ({
        ...option,
        value: false,
      })
    );

    setProviderRequestsFilterOptions(resetFilters);
    setDraftProviderRequestsFilterOptions(resetFilters);

    //Reset Requested Date Range
    setCreatedTimeStart(null);
    setCreatedTimeEnd(null);
    setCreatedTimeStartError("");
    setCreatedTimeEndError("");
    setCreatedTime([]);
    setCreatedTimeError("");
    // Reset Status
    setStatus([]);
    setStatusError("");
    // Reset Business Type
    setBusinessType([]);
    setBusinessTypeError("");
    // Inform parent component about reset
    props.onApplyFilters({});
  };

  const handleCreatedTimeDateRange = (from: Date | null, to: Date | null) => {
    setCreatedTimeStart(from ? dayjs(from) : null);
    setCreatedTimeEnd(to ? dayjs(to) : null);
    if (from) setCreatedTimeStartError("");
    if (to) setCreatedTimeEndError("");
  };

  const isCreatedTimeEnabled = draftProviderRequestsFilterOptions?.find(
    (opt: any) => opt.label === "Requested Date Range"
  )?.value;
  const isStatusEnabled = draftProviderRequestsFilterOptions?.find(
    (opt: any) => opt.label === "Status"
  )?.value;

  const renderFilterField = (optionLabel: string, menuOptions?: any[]) => {
    switch (optionLabel) {
      case "Requested Date Range":
        return (
          <CreatedTimeFilter
            value={"Custom"}
            onChange={() => { }}
            isCreatedTimeEnabled={isCreatedTimeEnabled}
            onDateRangeChange={handleCreatedTimeDateRange}
            createdTimeError={createdTimeError}
            createdTimeStartError={createdTimeStartError}
            createdTimeEndError={createdTimeEndError}
            setCreatedTimeFromDate={setCreatedTimeStart}
            setCretedTimeToDate={setCreatedTimeEnd}
            showDropdown={false}
            fromDate={createdTimeStart}
            toDate={createdTimeEnd}
          />
        );
      case "Status":
        return (
          <ProviderRequestStatusFilter
            value={status}
            onChange={setStatus}
            isStatusEnabled={
              draftProviderRequestsFilterOptions?.find(
                (opt: any) => opt.label === "Status"
              )?.value
            }
            error={statusError}
            statusOptions={menuOptions || []}
          />
        );
      case "Business Type":
       return (
        <ProviderRequestStatusFilter
          value={businessType}
          onChange={setBusinessType}
          isStatusEnabled={
            draftProviderRequestsFilterOptions?.find(
              (opt: any) => opt.label === "Business Type"
            )?.value
          }
          error={businessTypeError}
          statusOptions={menuOptions || []}
        />
       )
      default:
        return null;
    }
  };
  const handleDateValidation = (startDateVal, endDateVal) => {
    let isError = false;
    const minDate = dayjs("1900-01-01");
    const today = dayjs().endOf("day");
    const startRaw = startDateVal;
    const endRaw = endDateVal;
    const startDate = startRaw ? dayjs(startRaw) : null;

    const endDate = endRaw ? dayjs(endRaw) : null;

    // --- Start Date Validation ---
    if (startDate && !startDate?.isValid()) {
      setCreatedTimeStartError("Invalid start date");
      isError = true;
    } else if (!startDate) {
      setCreatedTimeStartError("Start date is required");
      isError = true;
    } else if (startDate.isBefore(minDate)) {
      setCreatedTimeStartError(`Invalid start date`);
      isError = true;
    } else if (startDate.isAfter(today)) {
      setCreatedTimeStartError("Start date cannot be in the future");
      isError = true;
    } else if (endDate && startDate.isAfter(endDate)) {
      setCreatedTimeStartError("Start date cannot be after end date");
      isError = true;
    } else {
      setCreatedTimeStartError("");
      isError = false;
    }

    // --- End Date Validation ---
    if (endDate && !endDate?.isValid()) {
      setCreatedTimeEndError("Invalid end date");
      isError = true;
    } else if (!endDate) {
      setCreatedTimeEndError("End date is required");
      isError = true;
    } else if (endDate.isBefore(minDate)) {
      setCreatedTimeEndError(`Invalid end date`);
      isError = true;
    } else if (endDate.isAfter(today)) {
      setCreatedTimeEndError("End date cannot be in the future");
      isError = true;
    } else if (startDate && endDate.isBefore(startDate)) {
      setCreatedTimeEndError("End date cannot be before start date");
      isError = true;
    }
    return isError;
  };
  const handleApplyFilters = () => {
    let hasError = false;

    const isCreatedTimeEnabled = draftProviderRequestsFilterOptions.find(
      (opt: any) => opt.label === "Requested Date Range"
    )?.value;
    const isStatusEnabled = draftProviderRequestsFilterOptions.find(
      (opt: any) => opt.label === "Status"
    )?.value;
    const filterData: any = {};
    const isBusinessTypeEnabled = draftProviderRequestsFilterOptions.find(
      (opt: any) => opt.label === "Business Type"
    )?.value;
    // ---------- REQUESTED DATE RANGE ----------
    if (isCreatedTimeEnabled) {
      if (createdTime.length === 0) {
        setCreatedTimeError("Select Requested Date Range");
        hasError = true;
      } else {
        setCreatedTimeError("");
      }
      hasError = handleDateValidation(createdTimeStart, createdTimeEnd) || hasError;
      if (!hasError) {
          filterData.createdTimeStart = createdTimeStart;
          filterData.createdTimeEnd = createdTimeEnd;
        }
      
    }
    if (isStatusEnabled) {
      if (status.length === 0) {
        setStatusError("Status cannot be empty");
        hasError = true;
      } else {
        setStatusError("");
        filterData.status = status;
      }
    }
    if (isBusinessTypeEnabled) {
      if (businessType.length === 0) {
        setBusinessTypeError("Business Type cannot be empty");
        hasError = true;
      } else {
        setBusinessTypeError("");
        filterData.businessType = businessType;
      }
    }
    // ---------- EXIT IF ERRORS ----------
    if (hasError) return;

    // ---------- APPLY FILTERS ----------
    onApplyFilters(filterData);
    setProviderRequestsFilterOptions(draftProviderRequestsFilterOptions);
    setIsOpenFilter(false); // Close the popup
  };

  return (
    <div className="provider-requests-filter-options-wrapper">
      <div className="provider-requests-filter-options-container">
        <div className="header-wrapper">
          <div className="provider-requests-filter-options-container-header">
            <div className="provider-requests-filter-options-container-header-text">
              Filter
            </div>
            <div className="provider-requests-filter-options-container-header-icon">
              <img
                src={closeIcon}
                alt="Filter Icon"
                onClick={() => {
                  setIsOpenFilter(false);
                }}
              />
            </div>
          </div>
         
        </div>
        <div className="provider-requests-filter-options-container-list">
          {draftProviderRequestsFilterOptions?.map((option: any) => (
            <div key={option?.label}>
              <label
                htmlFor={option?.label}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  ...(option?.value && { height: "10px", marginTop: "15px" }),
                }}
              >
                <Checkbox
                  checked={option?.value}
                  onChange={handleChange}
                  id={option?.label}
                />
                <ListItemText primary={option?.label} />
              </label>

              {option?.value && renderFilterField(option?.label, option?.options)}
            </div>
          ))}
         
        </div>
        {isAnyFilterSelected && (
          <div className="provider-requests-filter-buttons">
            <button
              className="cancel-btn"
              onClick={() => {
                handleReset();
              }}
            >
              Reset
            </button>
            <button
              className="action-btn"
              type="submit"
              onClick={handleApplyFilters}
            >
              Apply
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProviderRequestsFilterOptions;
